/**
 * Express-Shipping-Badge Sichtbarkeits-Logik
 *
 * Liest [data-express-badge]-Elemente und entscheidet anhand DE-Zeitzone
 * (Europe/Berlin) + Werktag + Cutoff (default 12 Uhr) + Feiertags-Liste,
 * ob Badge sichtbar ist und welche Text-Variante angezeigt wird.
 *
 * SSR: Badges starten mit [hidden]. JS entfernt [hidden] sobald entschieden.
 * Trade-Off: leichter Layout-Shift, aber rechtssicher (kein "Lieferung morgen"
 * am Wochenende oder Feiertag sichtbar).
 *
 * Source-of-Truth fuer Eligibility: product.metafields.custom.express_shipping (Liquid).
 */
(function () {
  'use strict';

  // Europe/Berlin-Zeit + DE-Feiertage stammen aus shared-delivery-utils.js
  // (window.DeliveryUtils) — eine gemeinsame Wahrheit mit custom-pdp-injector.js.
  // Source-of-Truth fuer Eligibility bleibt product.metafields.custom.express_shipping (Liquid).

  /**
   * Berechnet State fuer einen Badge.
   * @param {number} cutoffHour 0-23, Stunde nach der "today" zu "next" wird.
   * @returns {'today' | 'next' | 'hide'}
   *   today: vor Cutoff an Werktag (Mo-Fr, kein Feiertag) -> heute versendet
   *   next:  nach Cutoff an Werktag (Mo-Fr, kein Feiertag) -> Versand naechster Werktag
   *   hide:  Wochenende oder Feiertag -> Badge ausblenden (kein Versprechen)
   */
  function computeState(cutoffHour) {
    var U = window.DeliveryUtils;
    if (!U) return 'hide'; // Safety-Net: Util nicht geladen -> Badge ausblenden (kein falsches Versprechen)
    var now = U.getBerlinNow();
    if (now.weekday >= 6) return 'hide'; // Sa/So
    if (U.GERMAN_HOLIDAYS.has(now.isoDate)) return 'hide';
    return now.hour < cutoffHour ? 'today' : 'next';
  }

  function applyState(el, state) {
    if (state === 'hide') {
      el.setAttribute('hidden', '');
      return;
    }
    var textToday = el.querySelector('[data-express-text="today"]');
    var textNext = el.querySelector('[data-express-text="next"]');
    if (state === 'today') {
      if (textToday) textToday.removeAttribute('hidden');
      if (textNext) textNext.setAttribute('hidden', '');
    } else {
      if (textToday) textToday.setAttribute('hidden', '');
      if (textNext) textNext.removeAttribute('hidden');
    }
    el.removeAttribute('hidden');
  }

  /**
   * Move PDP-Badge from Standalone-Section-Wrapper (Empire rendert das ausserhalb
   * des Product-Containers, links unten) in den rechten Empire-Block.
   * Target: NACH der Lieferzeit-Box (.custom-delivery-estimate), VOR Anzahl-Row.
   * Fallback-Chain: stock-badge → qty-discount → atc-form.
   * Idempotent via data-repositioned + MutationObserver fuer late-injected delivery-estimate.
   */
  function repositionPdpBadge() {
    var wrapper = document.querySelector('.shopify-section.custom-express-pdp-wrapper');
    if (!wrapper || wrapper.getAttribute('data-repositioned') === '1') return false;
    var target = document.querySelector('.custom-delivery-estimate') ||
                 document.querySelector('.product-block--stock, [class*=stock]') ||
                 document.querySelector('.custom-qty-discount') ||
                 document.querySelector('.product-form');
    if (!target) return false;
    target.parentNode.insertBefore(wrapper, target.nextSibling);
    wrapper.setAttribute('data-repositioned', '1');
    return true;
  }

  /**
   * Watcht auf late-injected .custom-delivery-estimate (custom-pdp-injector.js
   * injiziert das async). Sobald sichtbar → move durchfuehren falls noch nicht
   * positioniert (bzw. re-position falls aktuell beim Fallback haengt).
   */
  function watchForDeliveryEstimate() {
    if (typeof MutationObserver === 'undefined') return;
    var observer = new MutationObserver(function () {
      var delivery = document.querySelector('.custom-delivery-estimate');
      var wrapper = document.querySelector('.shopify-section.custom-express-pdp-wrapper');
      if (delivery && wrapper) {
        // Re-position: immer nach delivery-estimate setzen, auch wenn schon geredet
        delivery.parentNode.insertBefore(wrapper, delivery.nextSibling);
        wrapper.setAttribute('data-repositioned', '1');
        observer.disconnect();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
    // Safety: nach 5s abschalten
    setTimeout(function () { observer.disconnect(); }, 5000);
  }

  function init() {
    repositionPdpBadge();
    watchForDeliveryEstimate();
    var badges = document.querySelectorAll('[data-express-badge]');
    if (!badges.length) return;
    badges.forEach(function (el) {
      var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10);
      if (isNaN(cutoffHour)) cutoffHour = 12;
      applyState(el, computeState(cutoffHour));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init bei Shopify-Section-Render-Events (Theme-Editor) und bei Cross-Sell-Lazy-Load.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('product-recommendations:loaded', init);
  // Privates Event vom Card-Enhancer (ersetzt missbrauchtes 'shopify:section:load', Bug-Fix 2026-06-08).
  document.addEventListener('custom:express-badge:refresh', init);
})();
